const viewSizeTypes = {
  desktop: 'large',
  tablet: 'medium',
  mobile: 'small',
};

export default viewSizeTypes;
